const { find, isUndefined } = require('lodash'), { cartItemMessageTemplates } = require('./cartitemmessages'), { trolleyQuantityValidation } = require('../trolley/trolley-quantity-validation.constant');

class CartItemMessages {
    constructor(stockcode) {
        this.stockcode = stockcode;

        this.errorMessage = null;
        this.matchedPromotionMessage = null;
        this.missedPromotionMessage = null;
    }
}

class CartItemMessageService {
    constructor($templateCache, $sce, settings, currencyCentsFilter) {
        this.$sce = $sce;
        this.currencyCentsFilter = currencyCentsFilter;

        cartItemMessageTemplates.forEach((template) => {
            $templateCache.put(template.id, template.content);
        });

        this.itemLimitReachedMessage = settings.trolley.itemLimitReached;
        this.itemNotUpdatedMessage = settings.trolley.itemNotUpdated;
        this.deliveryPassLimitMessage = settings.deliveryPass.exceededMaxActiveDeliveryPassesMessage;

        this.itemMessages = {};
    }

    getItemMessages(stockcode) {
        if (!(stockcode in this.itemMessages)) {
            this.itemMessages[stockcode] = new CartItemMessages(stockcode);
        }

        return this.itemMessages[stockcode];
    }

    removeItemMessages(stockcode) {
        delete this.itemMessages[stockcode];
    }

    clearErrors(stockcode) {
        this.getItemMessages(stockcode).errorMessage = null;
    }

    buildItemMessages(trolleyItem, error) {
        const itemMessages = this.getItemMessages(trolleyItem.Stockcode);

        if ((!trolleyItem.MatchedPromotions || !trolleyItem.MatchedPromotions.length) && (!trolleyItem.MissedPromotions || !trolleyItem.MissedPromotions.length) && !error && !itemMessages.errorMessage) {
            return new CartItemMessages(trolleyItem.Stockcode);
        }

        // Error may be null even though the error has not been acknowledged.
        // This can happen when using the trolley filter as the trolley items which do not match are destroyed,
        // and their local state is lost.
        //
        // Therefore, we keep the old error message even if error is not set. Error messages are cleared
        // by the cart-item when the quantity is successfully updated or the error is manually dismissed.
        itemMessages.errorMessage = error
            ? this.buildErrorMessages(trolleyItem, error, itemMessages.errorMessage)
            : itemMessages.errorMessage;

        itemMessages.matchedPromotionMessage = trolleyItem.MatchedPromotions && trolleyItem.MatchedPromotions.length
            ? this.buildMatchedPromotionMessage(trolleyItem, itemMessages.matchedPromotionMessage)
            : null;

        itemMessages.missedPromotionMessage = trolleyItem.MissedPromotions && trolleyItem.MissedPromotions.length
            ? this.buildMissedPromotionMessage(trolleyItem, itemMessages.missedPromotionMessage)
            : null;

        return itemMessages;
    }

    buildErrorMessages(trolleyItem, errorType, previousErrorMessage) {
        let message;

        switch (errorType) {
            case trolleyQuantityValidation.INVALID_QUANTITY:
                message = this.itemNotUpdatedMessage;
                break;
            case trolleyQuantityValidation.SUPPLY_LIMIT_EXCEEDED:
                message = this.itemLimitReachedMessage.replace('{itemLimit}', trolleyItem.SupplyLimit);
                break;
            case trolleyQuantityValidation.DELIVERY_PASS_LIMIT_EXCEEDED:
                message = this.deliveryPassLimitMessage;
                break;
            default:
                break;
        }

        if (previousErrorMessage && previousErrorMessage.key === message) {
            return previousErrorMessage;
        }

        return !message ? null : {
            key: message,
            class: 'errorQuantity alert alert--error',
            templateId: 'error-quantity',
            isDismissed: false,
            iconClass: 'iconww-QtyDeliveryLimit cartItemMessage-iconQuantityLimit',
            message: { errorMessage: this.$sce.trustAsHtml(message) },
        };
    }

    buildMatchedPromotionMessage(trolleyItem, previousMatchedPromotionMessage) {
        const matchedPromotion = find(trolleyItem.MatchedPromotions, promotion => promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff || promotion.IsDeferred || promotion.IsR1Promotion);

        const message = matchedPromotion && (matchedPromotion.IsDeferred || matchedPromotion.IsR1Promotion)
            ? matchedPromotion.Description
            : `You've saved ${this.currencyCentsFilter(trolleyItem.ListPrice * trolleyItem.QuantityInTrolley - trolleyItem.SalePrice)}`;

        if (previousMatchedPromotionMessage && previousMatchedPromotionMessage.key === message) {
            return previousMatchedPromotionMessage;
        }

        return {
            key: message,
            class: 'matchedPromotion alert alert--success',
            templateId: 'matched-promotion',
            isDismissed: false,
            iconClass: this.getPromotionIconClass(matchedPromotion),
            message: {
                promotionDescription: this.$sce.trustAsHtml(message),
            },
        };
    }

    buildMissedPromotionMessage(trolleyItem, previousMissedPromotionMessage) {
        const missedPromotion = find(trolleyItem.MissedPromotions, promotion => promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff);

        if (isUndefined(missedPromotion)) {
            return null;
        }

        if (previousMissedPromotionMessage && previousMissedPromotionMessage.key === missedPromotion.Description) {
            return previousMissedPromotionMessage;
        }

        return {
            key: missedPromotion.Description,
            class: 'missedPromotion alert alert--info',
            templateId: 'missed-promotion',
            isDismissed: false,
            iconClass: this.getPromotionIconClass(missedPromotion),
            message: {
                promotionDescription: missedPromotion.Description,
                promotionLink: missedPromotion.Link,
            },
        };
    }

    getPromotionIconClass(promotion) {
        return promotion && (promotion.IsDeferred || promotion.IsR1Promotion) ? 'iconww-RewardPointsEarned cartItemMessage-iconRewardPointsEarned' : 'iconww-TrolleySaver cartItemMessage-iconTrolleySaver';
    }
}

CartItemMessageService.$inject = ['$templateCache', '$sce', 'Settings', 'wowCurrencyCentsFilter'];

module.exports = {
    CartItemMessageService,
    CartItemMessages,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-item-message.service.js